import useCategoryPosts from '~/hooks/useLoaders/useCategoryPosts';

import getNormalizedCategory from '~/utils/getNormalizedCategory';

import FeaturedSection from './FeaturedSection';

interface Props {
  category: string;
  card: any;
  fontFamily: string;
  isNewWebBuilder?: boolean;
}

const CategorySection = ({ category, card, fontFamily, isNewWebBuilder = false }: Props) => {
  const { posts, isLoading } = useCategoryPosts({ category });
  const postsToRender = posts?.slice(0, 3);

  return (
    <FeaturedSection
      title={category}
      posts={postsToRender}
      card={card}
      fontFamily={fontFamily}
      isLoading={isLoading}
      ctaPath={`/t/${getNormalizedCategory(category)}`}
      isNewWebBuilder={isNewWebBuilder}
    />
  );
};

export default CategorySection;
